import { ReactNode } from 'react';
import styled from 'styled-components';

import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { DisplayL } from '@sorare/core/src/atoms/typography';
import { Ellipsis } from '@sorare/core/src/atoms/typography/Ellipsis';
import {
  laptopAndAbove,
  tabletAndAbove,
} from '@sorare/core/src/style/mediaQuery';

import background from './assets/background.jpg';

const Root = styled(Horizontal)`
  position: relative;
  isolation: isolate;
  background: url(${background});
  min-height: 300px;
  background-size: cover;
  background-position: center;
  overflow: hidden;
  align-items: stretch;
`;

const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    180deg,
    rgba(var(--c-rgb-black), 0) 0%,
    rgba(var(--c-rgb-black), 54%) 38%,
    var(--c-black) 100%
  );
  z-index: 4;
`;

const PlayerImage = styled.img`
  position: absolute;
  top: var(--double-and-a-half-unit);
  left: 0;
  max-width: 270px;
  transform: translateX(-50%);

  &.player-0 {
    left: 50%;
    z-index: 3;
  }
  &.player-1 {
    left: 65%;
    z-index: 2;
  }
  &.player-2 {
    left: 35%;
    z-index: 2;
  }
  &.player-3 {
    left: 80%;
    z-index: 1;
  }
  &.player-4 {
    left: 20%;
    z-index: 1;
  }
  &.player-5 {
    left: 95%;
  }
  &.player-6 {
    left: 5%;
  }
`;

const Content = styled(Vertical)`
  position: relative;
  z-index: 5;
  width: 100%;
  padding: var(--double-unit);
  @media ${tabletAndAbove} {
    padding: var(--triple-unit);
  }
`;

const TopLine = styled(Horizontal)`
  width: 100%;
  justify-content: flex-end;
`;

const Bottom = styled(Vertical)`
  flex-grow: 1;
  justify-content: flex-end;
`;

const Title = styled(DisplayL)`
  @media ${laptopAndAbove} {
    font-size: calc(12 * var(--unit));
    line-height: 1.1;
  }
`;

type Props = {
  title: ReactNode;
  playerUrls: string[];
  actions?: ReactNode;
  metas?: ReactNode;
};

export const DumbWatchlistHeader = ({
  title,
  playerUrls,
  actions,
  metas,
}: Props) => {
  return (
    <Root>
      {playerUrls.map((src, k) => (
        <PlayerImage key={src} className={`player-${k}`} src={src} />
      ))}
      <Overlay />
      <Content>
        <TopLine>{actions}</TopLine>
        <Bottom>
          <Title>
            <Ellipsis>{title}</Ellipsis>
          </Title>
          {metas}
        </Bottom>
      </Content>
    </Root>
  );
};
